ContactsHandler = App.loadClass "grower::handlers/contacts/Contacts_Handler"
DeleteDialog = App.loadClass "core::DeleteDialog"


class exports.Contacts_Tab_Handler extends ContactsHandler
    init: () ->
        @layoutUrl = "backend/grower/contacts/contactstab/load-layout"
        @layoutSelector = "#contactstab_contacts"

        msgwriter = App.sidebar.messageWriter()
        msgwriter.message_writer()
        msgwriter.message_writer('info', 'Loading...')

        @loadLayout()

    afterLoadLayout: (selector, data) ->
        ths = this
        $(@layoutSelector).find('.drop-btn').click( (e) ->
            btn = $(this)
            $.post(
                'backend/grower/contacts/contactstab/dropcontact-ajax',
                { 'contact_id': $(this).data('contact_id') },
                (json) ->
                    if(json.status.type is 'success')
                        btn.parents('tr').empty().append("<td class='removal_success'>Contact Dropped</td> <td></td> <td></td>")
                    else
                        #alert("ERROR: could not drop contact.   Technical Details-->#{json.status.msg}")
                        App.current_page.refreshSubHandlers()
            )
        )

        $(@layoutSelector).find('.block-btn').click( (e) ->
            btn = $(this)
            ths.createDeleteDialog('Block User?', $(this).data('contact_id'), 'contacts/contactstab/blockcontact-ajax', btn)
        )

        @bindPermissionSelChangeEvents(@layoutSelector)
        @tabLoadLayoutCallback(selector, data)

    bindPermissionSelChangeEvents: (layoutSelector) ->
        ths = this
        $(layoutSelector).find('.sel-change-permission').change( (e) ->
            sel = $(this)
            td = sel.parents('td')
            original = td.html()
            sel.replaceWith('<text class="saving">Saving...</text>')
            $.post(
                'backend/grower/contacts/contactstab/updatepermission-ajax',
                { 'contact_id': sel.data('contact_id'), 'permission_id': sel.val() },
                (json) ->
                    if(json.status.type is 'success')
                        #alert("Note, select changes to saving, while saving.\n (Comment out to see how fast this happens)")
                        td.empty().append(original)
                        td.children('select').replaceWith(json.data) #this should be a new ddm
                        ths.bindPermissionSelChangeEvents(layoutSelector)
                    else
                        #alert("ERROR: could not update permission.    Technical Details--> (#{json.status.type}, #{json.status.msg})")
                        App.current_page.refreshSubHandlers()
            )
        )

    createDeleteDialog: (type, user_id, saveUrl, btn) ->
        ths = this
        ## attach our own data to the generic Delete_Dialog class ###
        del = @createSubHandler(DeleteDialog)
        if del
            del.deleteItemID = user_id
            del.saveUrl = saveUrl
            del.delayAfterSuccess = true
            del.deleteMessage = 'Are you sure that you want to block this contact'
            del.deleteTitle = 'Block Contact'
            del.buttonText = 'Block'
            del.override_title = true
            del.override_message = true
            del.override_btnText = true
            del.successAction = () ->
                btn.parents('tr').empty().append("<td class='removal_success'>Contact Blocked</td> <td></td> <td></td>")
            del.init()
